export const FEED_WIDGET_WRAPPER = 'FeedWidget-wrapper' as const;
